module.exports = __webpack_public_path__ + "img/pms3.c34d5e0d.jpg";